import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

import LeadText from "app/pages/sales-intelligence/common-components/table-cells/components/LeadText/LeadText";

export const StyledCrmRecordCellWrapper = styled(Flex)`
    align-items: center;
    column-gap: 4px;
    min-width: 0;

    .ant-table-row:hover & {
        .link-out-container {
            display: flex;
        }
    }
`;

export const StyledLeadText = styled(LeadText)`
    min-width: 0;
    flex-grow: 1;
    flex-basis: 0;
`;
